import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { updatePaymentMethod } from "./index.js";

export default function useUpdatePaymentMethod() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ id, displayString, defaultPayment, defaultPayout }) =>
      updatePaymentMethod(ctx, id, {
        display_string: displayString,
        default_payment: defaultPayment,
        default_payout: defaultPayout,
      }),
    onSuccess: () => {
      // since a payment method is updated, fetching payment method should not be from cache
      queryClient.invalidateQueries({ queryKey: ["transaction-methods"] });
    },
  });
}
